<template>
  <div class="gather-elr-conent">
    <div class="lefts">
      <el-row :gutter="20">
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <div class="label">
              客户名称：

              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{
                  apApplyObject.ledgerName | customerName
                }}</span>
                <span class="value" slot="content">{{
                  apApplyObject.ledgerName | customerName
                }}</span>
              </el-tooltip>
            </div>
            <div class="label">
              是否保理业务：
              <span class="value" :title="apApplyObject.isApService? '是' : '否'">{{
                apApplyObject.isApService? '是' : '否'
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <div class="label">
              分公司：
              <span class="value" :title="apApplyObject.companyName">{{
                apApplyObject.companyName
              }}</span>
            </div>
            <div class="label">
              收款方法：
              <span class="value" :title=" apApplyObject.paymentMethod | payMethod">{{
                apApplyObject.paymentMethod | payMethod
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <div class="label">
              应开票金额：
              <span class="value" :title="apApplyObject.invoiceAmt">{{
                apApplyObject.invoiceAmt
              }}</span>
            </div>
            <!-- <div class="label">
                            备注：
                            <el-input class="text-box" v-model="apApplyObject.remark" placeholder="" style="width:120px" required></el-input>
                        </div> -->
            <div class="lable">
              <el-form
                :model="apApplyObject"
                :rules="rules"
                ref="remarkFrom"
                label-width="100px"
                class="demo-ruleForm"
              >
                <el-form-item label="备注" prop="remark" class="remake">
                  <el-input
                    v-model.trim="apApplyObject.remark"
                    :disabled="isSave"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>

        <el-col :span="4">
          <div class="grid-content bg-purple">
            <div class="label">
              核销总金额：
              <span class="value">{{ cancelAmt }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <div class="label">
              应收款金额：
              <span class="value">{{ apApplyObject.apRealAmt }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <div class="label">
              已上传发票金额：
              <span class="value">{{ accInvoiceAmt - preAmt }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
              <el-col >
          <div class="grid-content bg-purple">
            <div class="label">
              驳回原因：
              <el-tooltip class="item" effect="light" placement="top-start">
                <span class="value">{{ apApplyObject.rejectCause }}</span>
                <span class="value" slot="content">{{ apApplyObject.rejectCause }}</span>
              </el-tooltip>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
        <div class="rights">
            <div class="rights-l">
                <div v-for="(item, index) in taxRateData" :key="index" class="rights-d">
                    <span>业务类型：{{item.feeTaskTypeText}}</span> ，
                    <span>税率：{{item.taxRate}}</span> ，<span>应开票：{{item.value}} 元</span>
                </div>
                <div class="rights-t">总开票金额：{{taxRateData.totalAmountText}} 元</div>
            </div>
        </div>
  </div>
</template>

<script>
// import { parseTime } from '../../../../../../../utils';
const kREMARK = 81;
const validateInput = (rule, value, callback) => {
    const RegExp = /[%':'"%‘：”“’]/;
    if (RegExp.test(value)) {
        callback(new Error('中英文‘’:%“”为非法字符不能录入'));
    } else {
        callback();
    }
};
export default {
    props: {
        apApplyObject: {
            type: Object
        },
        invoiceUpAmt: {
            type: Number,
            default: 0.0
        },
        cancelAmt: {
            type: [Number, String],
            default: '0.0'
        },
        accInvoiceAmt: {
            type: [Number, String],
            default: 0.0
        },
        preAmt: {
            type: [Number, String],
            default: 0.0
        },
        isSave: {
            type: Boolean,
            default: true
        },
        taxRateData: {
            type: Array
        }
    },
    filters: {
        customerName: function (params) {
            if (params) {
                return params.replace(/[^\u4e00-\u9fa5]/gi, '');
            }
        },
        payMethod: function (params) {
            if (params === 1) {
                return '支票';
            } else if (params === 2) {
                return '纸质承兑支票';
            } else if (params === 3) {
                return '电汇';
            } else if (params === 4) {
                return '电汇承兑支票';
            } else if (params === 5) {
                return '信用证';
            } else if (params === 6) {
                return '现金';
            }
        }
    },
    data() {
        return {
            data: {},
            infoData: {},
            rules: {
                remark: [
                    {
                        required: true,
                        message: '请输入备注',
                        trigger: ['blur', 'change']
                    },
                    {
                        min: 1,
                        max: 80,
                        message: '长度必须在  80 个字符以内',
                        trigger: ['blur', 'change']
                    },
                    { validator: validateInput, trigger: ['blur', 'change'] }
                ]
            }
        };
    },
    watch: {
        apApplyObject: {
            immediate: true,
            deep: true,
            handler() {
                const regexp = /[%':'"%‘：”“’]/;
                if (this.apApplyObject.remark && this.apApplyObject.remark.length < kREMARK && !regexp.test(this.apApplyObject.remark)) {
                    this.$emit('remarkStatuSave', false);
                } else {
                    this.$emit('remarkStatuSave', true);
                }
            }
        }
    }
};
</script>

<style lang="less">
.gather-elr-conent {
  display: flex;
  .lefts {
    flex: 6;
    .remake {
      width: 70%;
    }
  }
  .rights {
    flex: 2;
    display: flex;
    .rights-l {
        color: #666;
        font-size: 14px;
        flex: 3;
        line-height: 20px;
        overflow: scroll;
    }
    .rights-t {
        margin-top: 20px;
    }
  }
  .demo-ruleForm {
    height: 30px;
    margin-left: -64px;
    width: 840px;
  }
}
</style>
